import React from 'react';
import { FeatureListContentfulModel } from '../../api/models/FeatureList';
import { ButtonContentfulModel } from 'src/api/models/Button';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import LinkBranded from 'src/elements/links/Link.branded';
import Features from './features';
import { FeatureListContainer, FeatureListContent, FeatureListitemsContent, HeadSection } from './featureList.engagementDrop.styles';

export interface FeatureListProps {
  title: string;
  descriptionParagraphs: string[];
  actionButton: ButtonContentfulModel;
  features: FeatureListContentfulModel['contentfulchildren'];
}

const FeatureListEngagement = ({ title, actionButton, features }: FeatureListProps): JSX.Element => {
  return (
    <FeatureListContainer>
      <FeatureListContent>
        <HeadSection>
          <Heading
            text={title}
            size="4rem"
            sizeSm="25px"
            align="center"
            color="#ffffff"
          />
          <Paragraph
            size="2rem"
            sizeSm="18px"
            color="#ffffff"
            weight="light"
            align="center"
          >
            Engagement is the key to breaking social media’s hold over our attention.
          </Paragraph>
          <Paragraph
            size="2rem"
            sizeSm="18px"
            color="#ffffff"
            weight="light"
            align="center"
          >
            With The Engagement Drop,  Mighty Networks is introducing a breakthrough recipe for engagement <strong>and</strong> independence.
          </Paragraph>
          <LinkBranded
            text={actionButton.text}
            url={actionButton.url}
            backgroundColor="#FF00FF"
            justify="center"
          />
        </HeadSection>
        <FeatureListitemsContent>
          <Features features={features} removeConfetti invert />
        </FeatureListitemsContent>
      </FeatureListContent>
    </FeatureListContainer>
  )
}

export default FeatureListEngagement;
